import React from "react";
import { Form, Input, Select } from "antd";


const FormInput = ({
  name,
  label,
  rules,
  placeholder,
  style,
  labelStyle,
  value,
  onChange,
  formFieldType,
  rows,
  labelCol,
  wrapperCol,
  disabled,
  options,
  showSearch,
  filterOption,
  optionLabelProp,
  maxChar,
  keypress,
  inputType,
  required,
  AutoFocus,
  colon,
  autoSize,
  status,
  suffix,
  autoComplete=false,
  hidden,

  mode
  
  

}) => {
  const renderFormField = () => {
    switch (formFieldType) {
      case "select":
        return (
          <Select
            className="w-full border border-gray-300 rounded-md p-1"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoComplete={autoComplete}
            mode={mode}
          
            
          >
            {options.map((option) => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        );
        case "Select":
          return (
            <Select
              className="w-full border border-gray-300 rounded-md p-1 form-item-left-align"
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              disabled={disabled}
              showSearch
            filterOption={filterOption}
            optionLabelProp={optionLabelProp}
            autoComplete={autoComplete}
            hidden={hidden}
            >
              {options.map((option) => (
            <Select.Option key={option.key} value={option.value} label={option.label}>
              {option.label}
            </Select.Option>
          ))}
            </Select>
          );
  
      case "textArea":
        return (
          <Input.TextArea
            className={style}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            rows={rows}
            autoSize={autoSize}
            maxLength={maxChar}
            autoComplete={autoComplete}
            hidden={hidden}
          />
        );

      case "input":
      default:
        return (
          <Input
            className={style}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            maxLength={maxChar}
            onKeyDown={keypress}
            type={inputType}
            autoFocus={AutoFocus}
            status={status}
            suffix={suffix}
            autoComplete={autoComplete}
            hidden={hidden}
            onKeyPress={keypress}
          />
        );
    }
  };

  return (
    <Form.Item
      name={name}
      label={<span style={labelStyle}>{label}</span>}
      rules={rules}
      colon={colon}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      required={required}
    
    >
      {renderFormField()}
    </Form.Item>
  );
};

export default FormInput;
